<template>
  <div class="eu-pb_5">
    <div class="emd-container _highlight_header">
      <div class="emd-container__header">
        <h2 class="emd-text _size_default _type_caption">
          {{ $t('title') }}:
          <span class="emd-text _type_hint">{{ charge.id }}</span>
        </h2>
        <div class="eu-flex eu-align-items_center eu-gap_3 eu-no-margin">
          <div class="eu-flex eu-align-items_center eu-no-margin eu-gap_3">
            <jade-button
              variant="primary-solid"
              size="small"
              icon="action-download"
              v-if="showCancellationLetter"
              @click="getLetter('Cancellation')"
            >
              {{ $t('refund-receipt') }}
            </jade-button>

            <jade-button
              variant="primary-solid"
              size="small"
              icon="arrow-forward"
              v-if="showRefundButton"
              @click="openModalRefund"
            >
              {{ $t('refund') }}
            </jade-button>

            <jade-button
              v-if="showSimulatorPaymentsButton"
              variant="primary-solid"
              size="small"
              icon="money-notes"
              @click="openModalSimulatorPayments"
            >
              {{ $t('simulator-payments') }}
            </jade-button>
          </div>

          <div
            style="height: 36px"
            v-if="showDivider"
          >
            <jade-divider direction="vertical" />
          </div>

          <div
            v-if="showActionsButton"
            id="jsDropdown"
            class="emd-dropdown _position_right"
          >
            <div class="emd-dropdown__trigger">
              <jade-action-button
                variant="primary-solid"
                size="small"
                icon="plus"
                dropdownIndicator
                @click="toogleDropdown"
              >
                {{ $t('actions.title') }}
              </jade-action-button>
            </div>
            <div
              class="emd-dropdown__content"
              v-bind:class="{ _active: showActionsDropdown }"
            >
              <nav class="emd-nav-list _direction_column _hoverble">
                <ul>
                  <li
                    class="emd-nav-list__item"
                    @click="resync"
                    v-if="permissionIsEnabled('charge.transaction:resync')"
                  >
                    <button
                      class="emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1"
                    >
                      <i class="uil uil-redo" />
                      <jade-text variant="text-small">
                        {{ $t('actions.resync-charge') }}
                      </jade-text>
                    </button>
                  </li>

                  <li
                    class="emd-nav-list__item"
                    @click="openRetryModal"
                    v-if="canRetryCharge"
                  >
                    <button
                      class="emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1"
                    >
                      <i class="uil uil-refresh" />
                      <jade-text variant="text-small">
                        {{ $t('actions.retry-charge') }}
                      </jade-text>
                    </button>
                  </li>

                  <li
                    class="emd-nav-list__item"
                    v-if="
                      charge.capture.show &&
                      componentIsEnabled('charge', 'capture') &&
                      permissionIsEnabled('charge:capture')
                    "
                    @click="openCaptureModal"
                  >
                    <button
                      class="emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1"
                    >
                      <i class="uil uil-check-circle" />
                      <jade-text variant="text-small">
                        {{ $t('actions.capture-charge') }}
                      </jade-text>
                    </button>
                  </li>

                  <li
                    class="emd-nav-list__item"
                    v-if="
                      charge.confirm.show &&
                      componentIsEnabled('charge', 'confirm') &&
                      permissionIsEnabled('charge:confirm')
                    "
                    @click="openConfirmModal"
                  >
                    <button
                      class="emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1"
                    >
                      <i class="uil uil-check-circle" />
                      <jade-text variant="text-small">
                        {{ $t('actions.confirm-charge') }}
                      </jade-text>
                    </button>
                  </li>

                  <li
                    class="emd-nav-list__item"
                    v-if="showAttemptButton"
                    @click="openAttemptModal"
                  >
                    <button
                      class="emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1"
                    >
                      <i class="uil uil-check-circle" />
                      <jade-text variant="text-small">
                        {{ $t('actions.attempt-charge') }}
                      </jade-text>
                    </button>
                  </li>

                  <li
                    class="emd-nav-list__item"
                    v-if="
                      charge.authorization_letter.show &&
                      permissionIsEnabled('charge.letter.authorization:get')
                    "
                    @click="getLetter('Authorization')"
                  >
                    <button
                      class="emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1"
                    >
                      <i class="uil uil-download-alt" />
                      <jade-text variant="text-small">
                        {{ $t('actions.payment-receipt') }}
                      </jade-text>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="emd-table-responsive">
        <DashTable
          :fields="fields"
          :items="chargeValues"
          :eventProps="tableEvents"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  JadeButton,
  JadeActionButton,
  JadeText,
  JadeDivider
} from '@/components/jade'
import DashTable from '@/components/project/molecules/Table.vue'
import { isPrepaid } from '@/enums/payment-method.enum'
import { simulatorPaymentsEnabled } from '@permissions/charges.permissions'

import sendEvent from '@utils/analiticaEventCaller.utils'

export default {
  name: 'ChargeDetailTable',
  components: {
    JadeButton,
    JadeDivider,
    JadeActionButton,
    JadeText,
    DashTable
  },
  data () {
    return {
      showActionsDropdown: false
    }
  },
  props: {
    charge: {
      required: true,
      type: Object
    },
    isCancelableBoleto: Boolean,
    showAttemptButton: Boolean,
    canRetryCharge: Boolean
  },
  computed: {
    ...mapGetters(['isTestAccount', 'businessModel', 'permissionIsEnabled']),
    tableEvents () {
      return {
        amplitudeInstance: 'chargesEvents',
        originId: {
          feature: 'actions',
          eventFunctionName: 'detailsOrderClicked'
        },
        customer_name: {
          feature: 'actions',
          eventFunctionName: 'detailsReceiverClicked'
        }
      }
    },
    showSimulatorPaymentsButton () {
      return simulatorPaymentsEnabled({
        status: this.charge.status,
        isTestAccount: this.isTestAccount,
        businessModel: this.businessModel,
        paymentMethod: this.charge.payment_method
      })
    },
    showCancellationLetter () {
      return (
        this.permissionIsEnabled('charge.letter.cancelation:get') &&
        (this.charge?.cancellation_letter?.show ||
          this.charge.boleto_cancellation_letter?.show)
      )
    },
    showRefundButton () {
      return (
        this.isCancelableBoleto ||
        (this.charge.cancel.show &&
          this.componentIsEnabled('charge', 'cancel') &&
          this.permissionIsEnabled('charge:cancel'))
      )
    },
    showDivider () {
      return (
        this.showActionsButton &&
        (this.showCancellationLetter || this.showRefundButton)
      )
    },
    showActionsButton () {
      return (
        this.permissionIsEnabled('charge.transaction:resync') ||
        (this.charge.capture.show &&
          this.componentIsEnabled('charge', 'capture') &&
          this.permissionIsEnabled('charge:capture')) ||
        (this.charge.confirm.show &&
          this.componentIsEnabled('charge', 'confirm') &&
          this.permissionIsEnabled('charge:confirm')) ||
        this.showAttemptButton ||
        (this.charge.authorization_letter.show &&
          this.permissionIsEnabled('charge.letter.authorization:get'))
      )
    },
    fields () {
      const FIELD = [
        {
          id: 'code',
          label: 'table.code',
          type: 'text'
        },
        {
          id: 'originId',
          label: 'table.origin-id',
          type:
            this.charge.origin &&
            this.permissionIsEnabled(`${this.charge.origin.type}:get`)
              ? 'link'
              : 'text',
          link: {
            to: this.charge.origin ? `${this.charge.origin.type}sDetail` : '',
            params: { id: 'originId' }
          }
        },
        {
          id: 'amount',
          label: 'table.amount',
          type: 'text'
        },
        {
          id: 'status',
          label: 'table.status',
          type: 'status'
        },
        {
          id: 'payment_method',
          label: 'table.payment-method',
          type: 'text'
        },
        {
          id: 'customer_name',
          label: 'table.customer-name',
          type: this.permissionIsEnabled('customer:get') ? 'link' : 'text',
          link: {
            to: 'customersDetail',
            params: { id: 'customer_id', tab: 'info' }
          }
        },
        {
          id: 'customer_email',
          label: 'table.customer-email',
          type: 'text'
        }
      ]

      return FIELD.map(item => ({
        ...item,
        label: this.$t(item.label)
      }))
    },
    isPrepaid () {
      return isPrepaid(this.charge.transactions[0])
    },
    chargeValues () {
      return [
        {
          originId: this.charge.origin
            ? this.charge.origin.id
            : this.$i18n.t('one-time-charge'),
          code: this.charge.code,
          amount: this.charge.amount,
          status: this.charge.status,
          payment_method: this.isPrepaid
            ? `${this.charge.payment_method} ${this.charge.last_transaction.funding_source}`
            : this.charge.payment_method,
          customer_name: this.charge.customer.name,
          customer_id: this.charge.customer.id,
          customer_email: this.charge.customer.email
        }
      ]
    }
  },
  methods: {
    eventCaller (functionName, action) {
      sendEvent({
        instanceName: 'chargesEvents',
        featureName: 'actions',
        functionName: functionName,
        metadata: action
      })
    },
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    },
    getLetter (type) {
      const actions = {
        Authorization: 'Comprovante de Pagamento',
        Cancellation: 'Comprovante de estorno'
      }
      this.eventCaller('detailsButtonClicked', actions[type])
      this.$emit('getLetter', type)
    },
    openModalSimulatorPayments () {
      this.eventCaller('detailsSimulatorPaymentsClicked')
      this.$emit('openModalSimulatorPayments')
    },
    openModalRefund () {
      this.eventCaller('detailsRefundClicked')
      this.$emit('openModalRefund')
    },
    resync () {
      this.eventCaller('detailsButtonClicked', 'Ressincronizar')
      this.$emit('resync')
    },
    toogleDropdown () {
      this.eventCaller('detailsButtonClicked')
      this.showActionsDropdown = !this.showActionsDropdown
    },
    closeActionsDropdown () {
      this.showActionsDropdown = false
    },
    openRetryModal () {
      this.eventCaller('detailsButtonClicked', 'Reprocessar')
      this.$emit('openRetryModal')
    },
    openCaptureModal () {
      this.eventCaller('detailsButtonClicked', 'Capturar')
      this.$emit('openCaptureModal')
    },
    openConfirmModal () {
      this.eventCaller('detailsButtonClicked', 'Confirmar')
      this.$emit('openConfirmModal')
    },
    openAttemptModal () {
      this.eventCaller('detailsButtonClicked', 'Retentar')
      this.$emit('openAttemptModal')
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Cobrança",
      "refund-receipt": "Comprovante de estorno",
      "refund": "Estornar",
      "simulator-payments": "Simular pagamento",
      "actions": {
        "title": "Ações",
        "capture-charge": "Capturar",
        "confirm-charge": "Confirmar",
        "attempt-charge": "Retentar",
        "payment-receipt": "Comprovante de pagamento",
        "resync-charge": "Ressincronizar",
        "retry-charge": "Reprocessar"
      },
      "table": {
        "origin-id": "ID de Origem",
        "code": "Código da cobrança",
        "amount": "Valor",
        "status": "Status",
        "payment-method": "Forma de pagamento",
        "customer-name": "Nome",
        "customer-email": "Email"
      },
      "one-time-charge": "Cobrança avulsa"
    },
    "en-US": {
      "title": "Charge",
      "refund-receipt": "Refund receipt",
      "refund": "Refund",
      "simulator-payments": "Simulate payment",
      "actions": {
        "title": "Actions",
        "capture-charge": "Capture",
        "confirm-charge": "Confirm",
        "attempt-charge": "Attempt",
        "payment-receipt": "Payment receipt",
        "resync-charge": "Resync",
        "retry-charge": "Reprocess"
      },
      "table": {
        "origin-id": "Origin ID",
        "code": "Charge code",
        "amount": "Amount",
        "status": "Status",
        "payment-method": "Payment method",
        "customer-name": "Name",
        "customer-email": "Email"
      },
      "one-time-charge": "One-time charge"
    }
  }
</i18n>
